export default "__VITE_ASSET__DDR58OGC__"